/** Commercial password policy — keep in sync with backend security_controls.validate_password_strength */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES = [
  { id: "length", label: `At least ${PASSWORD_MIN_LENGTH} characters`, test: (pw) => pw.length >= PASSWORD_MIN_LENGTH },
  { id: "lower", label: "One lowercase letter", test: (pw) => /[a-z]/.test(pw) },
  { id: "upper", label: "One uppercase letter", test: (pw) => /[A-Z]/.test(pw) },
  { id: "digit", label: "One number", test: (pw) => /\d/.test(pw) },
  { id: "special", label: "One symbol (!@#$%…)", test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export function evaluatePassword(password) {
  const pw = String(password || "");
  const checks = PASSWORD_RULES.map((rule) => ({
    ...rule,
    passed: rule.test(pw),
  }));
  const score = checks.filter((c) => c.passed).length;
  const valid = score === checks.length;
  let strength = "weak";
  if (valid) strength = "strong";
  else if (score >= 3) strength = "fair";
  return { checks, valid, strength, score, max: checks.length };
}

export function passwordPolicyError(password) {
  const { valid, checks } = evaluatePassword(password);
  if (valid) return null;
  const missing = checks.filter((c) => !c.passed).map((c) => c.label.toLowerCase());
  return `Password needs: ${missing.join(", ")}.`;
}
